export default __webpack_public_path__ + "static/media/Messages.5e38d84b.svg";